import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/auth/ProtectedRoute';

// Pages
import HomePage from './pages/HomePage';
import BadgeMakerPage from './pages/BadgeMakerPage';
import BadgeSizeSelection from './pages/BadgeSizeSelection';
import PolaroidSizeSelection from './pages/PolaroidSizeSelection';
import CanvaEditor from './pages/CanvaEditor';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import UsersPage from './pages/admin/UsersPage';

import './App.css';

export default function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="min-h-screen bg-gradient-to-br from-background via-background to-muted">
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignupPage />} />

            {/* Protected routes */}
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <HomePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/maker"
              element={
                <ProtectedRoute>
                  <BadgeSizeSelection />
                </ProtectedRoute>
              }
            />
            <Route
              path="/polaroid-maker"
              element={
                <ProtectedRoute>
                  <PolaroidSizeSelection />
                </ProtectedRoute>
              }
            />
            <Route
              path="/maker-old"
              element={
                <ProtectedRoute>
                  <BadgeMakerPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/editor"
              element={
                <ProtectedRoute>
                  <CanvaEditor />
                </ProtectedRoute>
              }
            />

            {/* Admin routes */}
            <Route
              path="/admin"
              element={
                <ProtectedRoute requireAdmin>
                  <UsersPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/users"
              element={
                <ProtectedRoute requireAdmin>
                  <UsersPage />
                </ProtectedRoute>
              }
            />
          </Routes>
          <Toaster position="top-center" richColors />
        </div>
      </Router>
    </AuthProvider>
  );
}
